export const classCreationGoalValueName = 'ClassCreationGoalValue'
export const classCreationGoalDateName = 'ClassCreationGoalDate'
export const lessonCompletionGoalValueName = 'LessonCompletionGoalValue'
export const lessonCompletionGoalDateName = 'LessonCompletionGoalDate'
export const programStartDateName = 'ProgramStartDate'
export const schoolwideGoalIsDisabledName = 'SchoolwideGoalIsDisabled'
export const goal3DateName = 'Goal3Date'
export const goal3TextName = 'Goal3Text'
export const goal4DateName = 'Goal4Date'
export const goal4TextName = 'Goal4Text'
export const goal5DateName = 'Goal5Date'
export const goal5TextName = 'Goal5Text'
